import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class VoiceActivateIcon extends AbstractIcon {
  static selector = "voice-activate-icon"

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <rect x="4" y="6" width="18" height="2"/>
        <rect x="4" y="12" width="18" height="2"/>
        <rect x="4" y="18" width="12" height="2"/>
        <polygon points="21 18 28 23 21 28 21 18"/>
      </svg>
`;
  }
}

componentsRegistryService.define(VoiceActivateIcon);